import { render } from "./PpcSettingsFilters.vue?vue&type=template&id=113aa356"
import script from "./PpcSettingsFilters.vue?vue&type=script&lang=js"
export * from "./PpcSettingsFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__